import React from 'react';
import { connect } from 'react-redux';
import DeleteFSObjectForm from 'components/event/FileSystem/DeleteFSObjectForm';
import { getFSObjectName } from 'components/event/FileSystem/fsObjectUtils';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { removeFSObject } from 'actions/Event';

import { clearModal } from 'actions';

import { Modal } from 'reactstrap';

const DeleteFSObjectModal = ({ remove, modalOpen, clearModal, fsObject }) => {
  const clearDeleteModal = clearModal.bind(null, 'DELETE_FS_OBJECT');

  const readyToShowForm = fsObject ? true : false;

  return (
    <Modal isOpen={modalOpen} toggle={clearDeleteModal}>
      <StyledModalHeader toggle={clearDeleteModal}>
        Delete {fsObject && getFSObjectName(fsObject)}
      </StyledModalHeader>
      <StyledModalBody>
        {readyToShowForm ? (
          <DeleteFSObjectForm
            fsObject={fsObject}
            onSubmit={(fsObjectId) => {
              remove(fsObjectId);
              clearDeleteModal();
            }}
            onCancel={clearDeleteModal}
          />
        ) : (
          <span />
        )}
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal }) => {
    const props = {
      modalOpen: modal && modal.type === 'DELETE_FS_OBJECT',
    };

    if (props.modalOpen) {
      return { ...props, fsObject: modal.initialValue };
    }

    return props;
  },
  {
    clearModal,
    remove: removeFSObject,
  },
)(DeleteFSObjectModal);
